import { render, staticRenderFns } from "./LivingInExcellence.vue?vue&type=template&id=00c4ca96&scoped=true"
import script from "./LivingInExcellence.vue?vue&type=script&lang=js"
export * from "./LivingInExcellence.vue?vue&type=script&lang=js"
import style0 from "./LivingInExcellence.vue?vue&type=style&index=0&id=00c4ca96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c4ca96",
  null
  
)

export default component.exports